export default __webpack_public_path__ + "static/media/suitemaster_1.30e15550.jpg";